import React from 'react'
import Title from './../../../../components/typography/title.component'
import Button from '../../../../components/buttons/buttons.component'
import styled from 'styled-components'
import Container from '../../../../components/layout/container.component'
import ModalConfirmation from './../../../../components/modal/modal-confirmation.component'
import AccordionSecondary from '../../../../components/accordion/accordion-secondary.component'
import { routes } from '../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../actions'
import { bindActionCreators } from 'redux'
import { UpdateClientService } from './services/update-client.service'
import { updateClientActions } from '../../employee/update-client-info/update-client.actions'
import { Creators as SiteCreators } from '../../../../ducks/site/site'

const StyledUpdate = styled.div`
	padding: 3rem 0;
`

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 5rem;
	* {
		color: white;
		margin-left: 2rem;
		text-decoration: none;
		&:first-child {
			margin-left: 0;
		}
	}
`

class ClientInformationPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.data = {}
		this.state = {
			loading: true,
			modalIsOpen: false,
			cancelationModalIsOpen: false
		}
	}

	componentWillMount() {
		this.props.showLoading()

		UpdateClientService.get().then(
			({ complementary, personal, termsAndConditions, muvicard }) => {
				this.complementary = complementary
				this.personal = personal
				this.termsAndConditions = termsAndConditions
				this.muvicard = muvicard
				this.setState(
					{
						loading: false
					},
					() =>
						this.refs.steps.openAll().then(() => this.props.hideLoading())
				)
			}
		)
	}

	async submit() {
		const { stepOne, stepTwo, stepFour, stepFive, billingAddress } = this.refs

		await stepOne.submit()
		await stepTwo.submit()
		await billingAddress.submit()
		await stepFour.submit()
		await stepFive.submit()

		return Promise.resolve()
	}

	handleSubmitStepOne = ({ rg }) => {
		this.data.rg = rg
	}

	handleSubmitStepTwo = ({ phone, birthday }) => {
		this.data.birthdate = birthday
		this.data.phone = phone
	}

	handleSubmitStepThree = ({
		zipCode,
		street,
		complement,
		number,
		neighborhood,
		city,
		state
	}) => {
		Object.assign(this.data, {
			zipCode,
			street,
			complement,
			number,
			neighborhood,
			city,
			state
		})
	}

	handleSubmitBillindAddressStep = addresses => {
		this.data.addresses = addresses
	}

	handleSubmitStepFour = ({ password }) => {
		this.data.password = password
	}

	handleSubmitStepFive = ({ newsletter }) => {
		this.data.newsletter = newsletter
		save.bind(this)()
	}

	render() {
		const { loading, modalIsOpen, cancelationModalIsOpen } = this.state

		return (
			<Container small>
				<Title>Meus dados</Title>
				{loading ? null : (
					<div>
						<StyledUpdate>
							<AccordionSecondary
								ref={'steps'}
								arrow={false}
								multiple={true}
								noClickable
								noAnimated
								items={UpdateClientService.getSections.call(this)}
							/>
						</StyledUpdate>
						<StyledButtonContainer>
							<Button
								danger
								type="button"
								onClick={() => {
									this.setState({ cancelationModalIsOpen: true })
								}}>
								Cancelar
							</Button>
							<Button
								primary
								type="button"
								onClick={handleClick.bind(this)}>
								Salvar
							</Button>
						</StyledButtonContainer>
					</div>
				)}
				<ModalConfirmation
					isOpen={modalIsOpen}
					title={'Salvar'}
					onResult={onResult.bind(this)}>
					Confirmar a alteração dos dados?
				</ModalConfirmation>
				<ModalConfirmation
					isOpen={cancelationModalIsOpen}
					title={'Cancelar'}
					onResult={cancelationOnResult.bind(this)}>
					Você tem certeza que deseja cancelar a operação? <br /> Todos os
					dados alterados serão descartados
				</ModalConfirmation>
			</Container>
		)
	}
}

function cancelationOnResult(confirmed) {
	this.setState({ cancelationModalIsOpen: false })
	if (!confirmed) return
	const { history } = this.props
	history.goBack()
}

function onResult(confirmed) {
	if (confirmed) {
		this.props.showLoading()
		UpdateClientService.post(this.data).then(
			handleSuccess.bind(this),
			handleError.bind(this)
		)
	}
	this.setState({ modalIsOpen: false })
}

function handleSuccess({ success, errors }) {
	const { danger, hideLoading, history } = this.props
	hideLoading()
	if (success) {
		this.props.success({
			message: 'Seus dados foram atualizados com sucesso'
		})
		history.push(`${routes.CLIENTE}/loja-muviflex`)
	} else if (errors && errors.length) {
		danger({ message: errors[0] })
	} else {
		danger('Não foi possível atualizar os dados. Tente novamente mais tarde.')
	}
}

function handleError() {
	const { danger, hideLoading } = this.props
	hideLoading()
	danger('Não foi possível atualizar os dados. Tente novamente mais tarde.')
}

async function handleClick() {
	this.data = {}
	await this.submit()
}

function save() {
	const { data, refs } = this
	const { passwordRef, passwordConfirmationRef } = refs.stepFour.refs.form
	const passValue = passwordRef.current.value
	const repassValue = passwordConfirmationRef.current.value
	const objKeys = Object.keys(data)
	const validFields = ['rg', 'phone', 'addresses', 'newsletter']

	const canSubmit = () => {
		const hasAllFields = validFields.every(field => objKeys.includes(field))
		const passwordIsFilled = !passValue.length && !repassValue.length
		const isChangingPassword = objKeys.includes('password')
		return hasAllFields && (passwordIsFilled || isChangingPassword)
	}

	if (canSubmit()) {
		this.setState({ modalIsOpen: true })
	} else {
		this.props.danger({
			message: 'Preencha os campos corretamente para prosseguir'
		})
	}
}

const mapStateToProps = ({ toast }) => ({ ...toast })

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions,
			...updateClientActions
		},
		dispatch
	)

const connectedClientInformationPageComponent = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ClientInformationPageComponent)
)

export { connectedClientInformationPageComponent as ModuleRootComponent }
